import loadable from '@loadable/component';

export const Introduction = loadable(() => import('./Introduction'));
export const SignupV1 = loadable(() => import('./SignupV1'));
export const SignupV2 = loadable(() => import('./SignupV2'));
export const SignupCountries = loadable(() => import('./SignupCountries'));
export const SignupCountryState = loadable(() =>
  import('./SignupCountryState')
);
